import { render, staticRenderFns } from "./view_expenses.vue?vue&type=template&id=f18fabd4&"
import script from "./view_expenses.vue?vue&type=script&lang=js&"
export * from "./view_expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports